import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sidebar } from '../dashboard_component';
import { labelAPI, cbtAPI, userAPI } from '../../api';
import { toast } from 'react-toastify';

function Admindashboard() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();
  const [labels, setLabels] = useState([]);
  const [totalCbts, setTotalCbts] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isNigeria, setIsNigeria] = useState(false);

  const handleToggle = () => setIsCollapsed(!isCollapsed);

  // Fetch user profile to determine country
  const fetchUserProfile = async () => {
    try {
      const res = await userAPI.getProfile();
      const country = res.data?.country || '';
      setIsNigeria(country?.toLowerCase() === 'nigeria');
    } catch (err) {
      console.error('Failed to fetch user profile', err);
      setIsNigeria(false);
    }
  };

  // Fetch all labels and total CBTs
  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const labelsRes = await labelAPI.getLabels();
      const labelsData = Array.isArray(labelsRes.data) ? labelsRes.data : [];
      setLabels(labelsData);
      
      // Total CBTs from sum of cbt_count in labels (already provided by backend)
      const total = labelsData.reduce((sum, label) => sum + (label.cbt_count || 0), 0);
      // setTotalCbts(total);
       const cbtRes = await cbtAPI.getMyCBTs(); // expects an endpoint that returns all user's CBTs
      const cbts = cbtRes.data?.data || cbtRes.data || [];
      setTotalCbts(cbts.length);

    } catch (error) {
      console.error('Dashboard data error', error);
      toast.error('Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserProfile();
    fetchDashboardData();
  }, []);

  const getIconComponent = (iconValue) => {
    const icons = {
      folder: '📁',
      document: '📄',
      star: '⭐',
      heart: '❤️',
      tag: '🏷️',
      bookmark: '🔖',
      lock: '🔒',
      'folder-open': '📂'
    };
    return icons[iconValue] || '📁';
  };

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-50 to-blue-50/30">
      <Sidebar isCollapsed={isCollapsed} onToggle={handleToggle} />
      
      <div 
        className={`flex-1 transition-all duration-300 pt-16 lg:pt-8 ${
          isCollapsed ? 'lg:ml-20' : 'lg:ml-64'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-blue-600 to-indigo-700 bg-clip-text text-transparent mb-3">
              Welcome to CBTHost
            </h1>
            <p className="text-gray-600 text-base lg:text-lg max-w-2xl">
              Manage your labels, CBTs, and track performance
            </p>
          </div>

          {/* Subscription Section */}
          <div className="mb-10 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-2xl shadow-xl p-5 sm:p-6 text-white">
            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
              <div className="flex-1">
                <div className="flex items-center mb-3">
                  <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center mr-3">
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
                    </svg>
                  </div>
                  <h2 className="text-xl sm:text-2xl font-bold">
                    {isNigeria ? 'Unlock Advanced Analytics' : 'Premium Subscription'}
                  </h2>
                </div>
                {isNigeria ? (
                  <>
                    {/* <p className="text-blue-100 text-base sm:text-lg mb-4 max-w-3xl">
                      Subscribe to our <span className="font-semibold">Admin Analytics Service</span> to access cloud-hosted reporting, 
                      unlimited users under your account, and priority support. Your analytics dashboard will be fully activated within 
                      <span className="font-bold"> 24 hours</span> after payment.
                    </p> */}
                    <p className="text-blue-100 text-base sm:text-lg mb-4 max-w-3xl">
  Subscribe to our <span className="font-semibold">Admin Analytics Service</span>. 
  Your analytics dashboard will be activated within 
  <span className="font-bold"> 24 hours</span> after payment.
  <br /><br />
  <span className="text-yellow-200 font-medium">
    Users outside Nigeria should select <span className="font-semibold">Crypto</span> on the payment page to get the USDT ERC20 wallet payment instructions.
  </span>
</p>
                    <div className="flex flex-wrap gap-3 text-sm">
                      <div className="flex items-center"><svg className="w-5 h-5 text-green-300 mr-2" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg><span>Cloud-hosted analytics dashboard</span></div>
                      <div className="flex items-center"><svg className="w-5 h-5 text-green-300 mr-2" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg><span>Unlimited instructors/users</span></div>
                      <div className="flex items-center"><svg className="w-5 h-5 text-green-300 mr-2" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg><span>Priority premium support</span></div>
                    </div>
                  </>
                ) : (
                  <div className="bg-white/10 rounded-xl p-4 mt-2">
                    {/* <p className="text-white text-lg font-medium">📱 For non‑Nigerian users, please contact our support on WhatsApp to activate your premium subscription.</p> */}
                    <p className="text-blue-100 text-base sm:text-lg mb-4 max-w-3xl">
  Subscribe to our <span className="font-semibold">Admin Analytics Service</span>. 
  Your analytics dashboard will be activated within 
  <span className="font-bold"> 24 hours</span> after payment.
  <br /><br />
  <span className="text-yellow-200 font-medium">
    Users outside Nigeria should select <span className="font-semibold">Crypto</span> on the payment page to get the USDT ERC20 wallet payment instructions.
  </span>
</p>
                    <a 
                      href="https://wa.me/2348113315252" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="inline-flex items-center mt-3 bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-5 rounded-lg transition"
                    >
                      <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.198.297-.767.967-.94 1.165-.173.198-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.614-.916-2.21-.242-.579-.487-.5-.669-.51-.173-.01-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.298-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.708.306 1.26.489 1.69.625.71.227 1.355.195 1.866.118.57-.085 1.758-.718 2.006-1.413.248-.695.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347z"/></svg>
                      Chat with Admin
                    </a>
                  </div>
                )}
              </div>
              {isNigeria && (
                <button
                  onClick={() => navigate('/cbt_creator/payment')}
                  className="bg-white text-blue-600 hover:bg-blue-50 font-bold py-2.5 px-5 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 whitespace-nowrap text-sm sm:text-base"
                >
                  <div className="flex items-center">
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    View Subscription Plans
                  </div>
                </button>
              )}
            </div>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12">
            <div className="bg-white rounded-2xl shadow-md p-6 border border-blue-100">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-500 text-sm">Total Folders (Labels)</p>
                  <p className="text-3xl font-bold text-gray-800">{labels.length}</p>
                </div>
                <div className="bg-blue-100 p-3 rounded-full">
                  <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-md p-6 border border-green-100">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-500 text-sm">Total CBTs Created</p>
                  <p className="text-3xl font-bold text-gray-800">{totalCbts}</p>
                </div>
                <div className="bg-green-100 p-3 rounded-full">
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Labels Grid (Folder View) */}
          <div className="mb-12">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-6">
              <h2 className="text-2xl font-bold text-gray-800">Your Folders</h2>
              <button
                onClick={() => navigate('/cbt_creator/label-selector')}
                className="text-indigo-600 hover:text-indigo-800 font-medium flex items-center gap-1 text-sm"
              >
                Manage Labels
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>

            {loading ? (
              <div className="flex justify-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                {/* Static "All Folders" Card */}
                <div
                  onClick={() => navigate('/cbt_creator/cbts')}
                  className="group bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md hover:border-indigo-300 transition-all duration-200 cursor-pointer"
                >
                  <div className="p-4">
                    <div className="flex items-start justify-between">
                      <div className="w-12 h-12 rounded-xl flex items-center justify-center text-2xl bg-indigo-50 text-indigo-600">
                        📁
                      </div>
                      <span className="bg-gray-100 text-gray-600 text-xs font-medium px-2 py-1 rounded-full">
                        {totalCbts} CBT{totalCbts !== 1 ? 's' : ''}
                      </span>
                    </div>
                    <h3 className="mt-3 font-semibold text-gray-800">
                      All Folders
                    </h3>
                    <p className="text-xs text-gray-400 mt-1">
                      Click to view all tests
                    </p>
                  </div>
                </div>

                {/* Dynamic Labels */}
                {labels.map(label => {
                  const iconChar = getIconComponent(label.icon);
                  const labelColor = label.color || '#3B82F6';
                  const cbtCount = label.cbt_count || 0;
                  return (
                    <div
                      key={label.label_id}
                      onClick={() => navigate(`/cbt_creator/cbts?label_id=${label.label_id}`)}
                      className="group bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all duration-200 cursor-pointer hover:border-indigo-300"
                    >
                      <div className="p-4">
                        <div className="flex items-start justify-between">
                          <div
                            className="w-12 h-12 rounded-xl flex items-center justify-center text-2xl mb-3"
                            style={{ backgroundColor: `${labelColor}20` }}
                          >
                            <span style={{ color: labelColor }}>{iconChar}</span>
                          </div>
                          <span className="bg-gray-100 text-gray-600 text-xs font-medium px-2 py-1 rounded-full">
                            {cbtCount} CBT{cbtCount !== 1 ? 's' : ''}
                          </span>
                        </div>
                        <h3 className="font-semibold text-gray-800 truncate" title={label.name}>
                          {label.name}
                        </h3>
                        <p className="text-xs text-gray-400 mt-1">Click to view tests</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Quick Links Footer */}
          <div className="mt-16 pt-8 border-t border-gray-200">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="text-center md:text-left">
                <h4 className="text-lg font-semibold text-gray-800 mb-2">Need Help?</h4>
                <p className="text-gray-600 text-sm">
                  Check our documentation or contact support for assistance
                </p>
              </div>
              <div className="flex flex-wrap justify-center gap-3">
                {isNigeria ? (
                  <button
                    onClick={() => navigate('/cbt_creator/payment')}
                    className="bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white px-5 py-2.5 rounded-xl font-semibold shadow-md hover:shadow-lg transition-all text-sm"
                  >
                    Manage Subscription
                  </button>
                ) : (
                  <a
                    href="https://wa.me/2348113315252"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white px-5 py-2.5 rounded-xl font-semibold shadow-md hover:shadow-lg transition-all flex items-center gap-2 text-sm"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.198.297-.767.967-.94 1.165-.173.198-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.614-.916-2.21-.242-.579-.487-.5-.669-.51-.173-.01-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.298-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.708.306 1.26.489 1.69.625.71.227 1.355.195 1.866.118.57-.085 1.758-.718 2.006-1.413.248-.695.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347z"/></svg>
                    WhatsApp Support
                  </a>
                )}
                <button
                  onClick={() => window.open('https://cbthost.com/support', '_blank')}
                  className="bg-gray-100 hover:bg-gray-200 text-gray-800 px-5 py-2.5 rounded-xl font-semibold transition-colors text-sm"
                >
                  Contact Support
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Admindashboard;